import { render, staticRenderFns } from "./ForgetPswPage.vue?vue&type=template&id=6472ea52&"
import script from "./ForgetPswPage.vue?vue&type=script&lang=js&"
export * from "./ForgetPswPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports